/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Stage_Picked_UpInputs */

const tr_geliver_tracking_stage_picked_up = /** @type {(inputs: Geliver_Tracking_Stage_Picked_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurye Aldı`)
};

const en_geliver_tracking_stage_picked_up = /** @type {(inputs: Geliver_Tracking_Stage_Picked_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picked Up`)
};

const de_geliver_tracking_stage_picked_up = /** @type {(inputs: Geliver_Tracking_Stage_Picked_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgeholt`)
};

const ru_geliver_tracking_stage_picked_up = /** @type {(inputs: Geliver_Tracking_Stage_Picked_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забрано`)
};

/**
* | output |
* | --- |
* | "Picked Up" |
*
* @param {Geliver_Tracking_Stage_Picked_UpInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_stage_picked_up = /** @type {((inputs?: Geliver_Tracking_Stage_Picked_UpInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Stage_Picked_UpInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_stage_picked_up(inputs)
	if (locale === "de") return de_geliver_tracking_stage_picked_up(inputs)
	if (locale === "ru") return ru_geliver_tracking_stage_picked_up(inputs)
	return tr_geliver_tracking_stage_picked_up(inputs)
});